import API from "..";
export default class PrintLabelOptions {
  
  static async getAll() {
    const api = await API();
    const { data } = await api.get(`/printlabelOptions`);
    return data;
  }

}